import React from "react";

import AbstractComponent from "components/Abstract";
import Button from "components/Button";
import Input from "components/Input";

import { ReactComponent as EyeIcon } from 'icons/login/eye.svg';
import { ReactComponent as EyeCloseIcon } from 'icons/login/eyeClose.svg';

import './index.less';
import './themes/default.less';

export default class Login extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            showPass: false,
        };
    }

    componentDidMount() {
        localStorage.setItem('token', '');

        this._helper.storage('cacheDates', '');
    }

    async login() {
        const username = this.usernameInput.validate();
        const password = this.passwordInput.validate();

        if (!username || !password)
            return;

        this._helper.showLoading();

        const { access_token, employee } = await this._request.auth.login({ username, password });
        if (access_token) {
            this._helper.storage("employee", employee || {});

            this._helper.login(access_token);
        }

        this._helper.hideLoading();
    }

    insertInput(key, label, { type, required }) {
        const isPass = key === "password";

        if (isPass && this.state.showPass)
            type = "text";

        const fn = this.toggleState.bind(this, "showPass");
        const iconRight = isPass ? (this.state.showPass ? <EyeCloseIcon className="eyeClose hand" onClick={fn} /> : <EyeIcon className="eye hand" onClick={fn} />) : null;

        return (
            <Input
                ref={el => this[`${key}Input`] = el}
                type={type}
                label={`login.${label}`}
                placeHolder={`login.${label}Ph`}
                iconRight={iconRight}
                required={required === undefined ? true : required}
                onEnter={this.login.bind(this)}
            />
        );
    }

    renderForm() {
        return (
            <div className="form flex col gap16">
                <div className="label text windowTitle">{this.tr("login", "auth")}</div>
                {this.insertInput("username", "login", {})}
                {this.insertInput("password", "pass", { type: "password" })}
                <div className="flex end">
                    <div className="forgot text p1 hand">{this.tr("login", "forgotPass")}</div>
                </div>
                <Button label={"login.signin"} onClick={this.login.bind(this)} />
            </div>
        );
    }

    renderLangs() {
        return (
            <div className="langs flex end text button1 gap8">
                {this._config.langs.map(key => {
                    const active = this._helper.currentLanguage === key ? "active" : "hand";

                    return (
                        <div key={key} className={`lang ${active}`} onClick={this.changeLanguage.bind(this, key)}>{key}</div>
                    );
                })}
            </div>
        );
    }

    render() {
        return (
            <div className="loginPage flex1 flex">
                <div className="left flex1 flex col">
                    <div className="header flex">
                        <div className="flex1">
                            {this.insertLogo()}
                            <div className="text p1">{this.tr("login", "title")}</div>
                        </div>
                        <div>
                            <div className="text p2">{this.tr("login", "support")}</div>
                            <div className="text p1 phone">8 800 555 29 81</div>
                        </div>
                    </div>
                    <div className="container flex1 flex centerAll">
                        {this.renderForm()}
                    </div>
                    <div className="footer text p1">{"© 2023 " + this.tr("login", "rights") + ", ClinicIQ.ru"}</div>
                </div>
                <div className="right flex1">
                    {this.renderLangs()}
                </div>
            </div>
        );
    }
}
